import React from "react";
import PropTypes from "prop-types";

/**
 * A component that represents a brand heading.
 * @param {Object} props - The props.
 * @param {string} props.title - The title.
 * @param {string} props.subtitle - The subtitle.
 * @param {string} props.description - The description.
 * @param {string} props.category - The category.
 * @param {string} props.fontSize - The font size.
 * @param {boolean} props.enableBoldTitle - Whether to enable bold title.
 * @returns {JSX.Element} The component.
 * @example
 * <BrandHeading
 * title="Title"
 * subtitle="Subtitle"
 * description="Description"
 * category="Category"
 * fontSize="3"
 * enableBoldTitle={true}
 * />
 */
const BrandHeading = ({ title, subtitle, description, category, fontSize, enableBoldTitle }) => {
  let clazz = {
    category: [],
    title: [],
    subtitle: [],
    description: [],
  };

  if (fontSize === "3") {
    clazz.category.push("font-size-0");
    clazz.title.push("font-size-3");
    clazz.subtitle.push("font-size-1");
    clazz.description.push("font-size-0");
  } else if (fontSize === "2") {
    clazz.category.push("font-size--1");
    clazz.title.push("font-size-2");
    clazz.subtitle.push("font-size-0");
    clazz.description.push("font-size--1");
  }

  clazz.title.push(enableBoldTitle ? "avenir-bold" : "avenir-regular");

  return (
    <div className="brand-heading-container">
      {category && <p className={`brand-heading__category ${clazz.category.join(" ")}`}>{category}</p>}
      {title && <h1 className={`brand-heading__title ${clazz.title.join(" ")}`}>{title}</h1>}
      {subtitle && <p className={`brand-heading__subtitle ${clazz.subtitle.join(" ")}`}>{subtitle}</p>}
      {description && <p className={`brand-heading__description ${clazz.description.join(" ")}`}>{description}</p>}
    </div>
  );
};

BrandHeading.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  category: PropTypes.string,
  fontSize: PropTypes.string,
  enableBoldTitle: PropTypes.bool,
};

export default BrandHeading;
